const countries: {
	code: string;
	label: string;
	phone: string;
	highlight?: boolean;
}[] = [
	{ code: "CO", label: "Colombia", phone: "57", highlight: true },
	{ code: "US", label: "Estados Unidos", phone: "1" },
	{ code: "AR", label: "Argentina", phone: "54" },
	{ code: "BO", label: "Bolivia", phone: "591" },
	{ code: "BR", label: "Brasil", phone: "55" },
	{ code: "CL", label: "Chile", phone: "56" },
	{ code: "EC", label: "Ecuador", phone: "593" },
	{ code: "GY", label: "Guyana", phone: "592" },
	{ code: "PY", label: "Paraguay", phone: "595" },
	{ code: "PE", label: "Perú", phone: "51" },
	{ code: "UY", label: "Uruguay", phone: "598" },
	{ code: "VE", label: "Venezuela", phone: "58" },
	{ code: "AF", label: "Afganistán", phone: "93" },
	{ code: "AL", label: "Albania", phone: "355" },
	{ code: "DE", label: "Alemania", phone: "49" },
	{ code: "AD", label: "Andorra", phone: "376" },
	{ code: "AO", label: "Angola", phone: "244" },
	{ code: "AI", label: "Anguila", phone: "1264" },
	{ code: "AG", label: "Antigua y Barbuda", phone: "1268" },
	{ code: "SA", label: "Arabia Saudita", phone: "966" },
	{ code: "DZ", label: "Argelia", phone: "213" },
	{ code: "AM", label: "Armenia", phone: "374" },
	{ code: "AW", label: "Aruba", phone: "297" },
	{ code: "AU", label: "Australia", phone: "61" },
	{ code: "AT", label: "Austria", phone: "43" },
	{ code: "AZ", label: "Azerbaiyán", phone: "994" },
	{ code: "BE", label: "Bélgica", phone: "32" },
	{ code: "BS", label: "Bahamas", phone: "1242" },
	{ code: "BH", label: "Bahrein", phone: "973" },
	{ code: "BD", label: "Bangladesh", phone: "880" },
	{ code: "BB", label: "Barbados", phone: "1246" },
	{ code: "BZ", label: "Belice", phone: "501" },
	{ code: "BJ", label: "Benín", phone: "229" },
	{ code: "BT", label: "Bhután", phone: "975" },
	{ code: "BY", label: "Bielorrusia", phone: "375" },
	{ code: "MM", label: "Birmania", phone: "95" },
	{ code: "BA", label: "Bosnia y Herzegovina", phone: "387" },
	{ code: "BW", label: "Botsuana", phone: "267" },
	{ code: "BN", label: "Brunéi", phone: "673" },
	{ code: "BG", label: "Bulgaria", phone: "359" },
	{ code: "BF", label: "Burkina Faso", phone: "226" },
	{ code: "BI", label: "Burundi", phone: "257" },
	{ code: "CV", label: "Cabo Verde", phone: "238" },
	{ code: "KH", label: "Camboya", phone: "855" },
	{ code: "CM", label: "Camerún", phone: "237" },
	{ code: "CA", label: "Canadá", phone: "1" },
	{ code: "TD", label: "Chad", phone: "235" },
	{ code: "CN", label: "China", phone: "86" },
	{ code: "CY", label: "Chipre", phone: "357" },
	{ code: "VA", label: "Ciudad del Vaticano", phone: "39" },
	{ code: "KM", label: "Comoras", phone: "269" },
	{ code: "CG", label: "República del Congo", phone: "242" },
	{ code: "CD", label: "República Democrática del Congo", phone: "243" },
	{ code: "KP", label: "Corea del Norte", phone: "850" },
	{ code: "KR", label: "Corea del Sur", phone: "82" },
	{ code: "CI", label: "Costa de Marfil", phone: "225" },
	{ code: "CR", label: "Costa Rica", phone: "506" },
	{ code: "HR", label: "Croacia", phone: "385" },
	{ code: "CU", label: "Cuba", phone: "53" },
	{ code: "CW", label: "Curazao", phone: "5999" },
	{ code: "DK", label: "Dinamarca", phone: "45" },
	{ code: "DM", label: "Dominica", phone: "1767" },
	{ code: "EG", label: "Egipto", phone: "20" },
	{ code: "SV", label: "El Salvador", phone: "503" },
	{ code: "AE", label: "Emiratos Árabes Unidos", phone: "971" },
	{ code: "ER", label: "Eritrea", phone: "291" },
	{ code: "SK", label: "Eslovaquia", phone: "421" },
	{ code: "SI", label: "Eslovenia", phone: "386" },
	{ code: "ES", label: "España", phone: "34" },
	{ code: "EE", label: "Estonia", phone: "372" },
	{ code: "ET", label: "Etiopía", phone: "251" },
	{ code: "PH", label: "Filipinas", phone: "63" },
	{ code: "FI", label: "Finlandia", phone: "358" },
	{ code: "FJ", label: "Fiyi", phone: "679" },
	{ code: "FR", label: "Francia", phone: "33" },
	{ code: "GA", label: "Gabón", phone: "241" },
	{ code: "GM", label: "Gambia", phone: "220" },
	{ code: "GE", label: "Georgia", phone: "995" },
	{ code: "GH", label: "Ghana", phone: "233" },
	{ code: "GI", label: "Gibraltar", phone: "350" },
	{ code: "GD", label: "Granada", phone: "1473" },
	{ code: "GR", label: "Grecia", phone: "30" },
	{ code: "GL", label: "Groenlandia", phone: "299" },
	{ code: "GP", label: "Guadalupe", phone: "590" },
	{ code: "GU", label: "Guam", phone: "1671" },
	{ code: "GT", label: "Guatemala", phone: "502" },
	{ code: "GF", label: "Guayana Francesa", phone: "594" },
	{ code: "GG", label: "Guernsey", phone: "44" },
	{ code: "GN", label: "Guinea", phone: "224" },
	{ code: "GQ", label: "Guinea Ecuatorial", phone: "240" },
	{ code: "GW", label: "Guinea-Bissau", phone: "245" },
	{ code: "HT", label: "Haití", phone: "509" },
	{ code: "HN", label: "Honduras", phone: "504" },
	{ code: "HK", label: "Hong kong", phone: "852" },
	{ code: "HU", label: "Hungría", phone: "36" },
	{ code: "IN", label: "India", phone: "91" },
	{ code: "ID", label: "Indonesia", phone: "62" },
	{ code: "IR", label: "Irán", phone: "98" },
	{ code: "IQ", label: "Irak", phone: "964" },
	{ code: "IE", label: "Irlanda", phone: "353" },
	{ code: "IM", label: "Isla de Man", phone: "44" },
	{ code: "CX", label: "Isla de Navidad", phone: "61" },
	{ code: "NF", label: "Isla Norfolk", phone: "672" },
	{ code: "IS", label: "Islandia", phone: "354" },
	{ code: "BM", label: "Islas Bermudas", phone: "1441" },
	{ code: "KY", label: "Islas Caimán", phone: "1345" },
	{ code: "CC", label: "Islas Cocos (Keeling)", phone: "61" },
	{ code: "CK", label: "Islas Cook", phone: "682" },
	{ code: "AX", label: "Islas de Åland", phone: "358" },
	{ code: "FO", label: "Islas Feroe", phone: "298" },
	{
		code: "GS",
		label: "Islas Georgias del Sur y Sandwich del Sur",
		phone: "500",
	},
	{ code: "MV", label: "Islas Maldivas", phone: "960" },
	{ code: "FK", label: "Islas Malvinas", phone: "500" },
	{ code: "MP", label: "Islas Marianas del Norte", phone: "1670" },
	{ code: "MH", label: "Islas Marshall", phone: "692" },
	{ code: "PN", label: "Islas Pitcairn", phone: "870" },
	{ code: "SB", label: "Islas Salomón", phone: "677" },
	{ code: "TC", label: "Islas Turcas y Caicos", phone: "1649" },
	{
		code: "UM",
		label: "Islas Ultramarinas Menores de Estados Unidos",
		phone: "246",
	},
	{ code: "VG", label: "Islas Vírgenes Británicas", phone: "1284" },
	{ code: "VI", label: "Islas Vírgenes de los Estados Unidos", phone: "1340" },
	{ code: "IL", label: "Israel", phone: "972" },
	{ code: "IT", label: "Italia", phone: "39" },
	{ code: "JM", label: "Jamaica", phone: "1876" },
	{ code: "JP", label: "Japón", phone: "81" },
	{ code: "JE", label: "Jersey", phone: "44" },
	{ code: "JO", label: "Jordania", phone: "962" },
	{ code: "KZ", label: "Kazajistán", phone: "7" },
	{ code: "KE", label: "Kenia", phone: "254" },
	{ code: "KG", label: "Kirguistán", phone: "996" },
	{ code: "KI", label: "Kiribati", phone: "686" },
	{ code: "KW", label: "Kuwait", phone: "965" },
	{ code: "LB", label: "Líbano", phone: "961" },
	{ code: "LA", label: "Laos", phone: "856" },
	{ code: "LS", label: "Lesoto", phone: "266" },
	{ code: "LV", label: "Letonia", phone: "371" },
	{ code: "LR", label: "Liberia", phone: "231" },
	{ code: "LY", label: "Libia", phone: "218" },
	{ code: "LI", label: "Liechtenstein", phone: "423" },
	{ code: "LT", label: "Lituania", phone: "370" },
	{ code: "LU", label: "Luxemburgo", phone: "352" },
	{ code: "MX", label: "México", phone: "52" },
	{ code: "MC", label: "Mónaco", phone: "377" },
	{ code: "MO", label: "Macao", phone: "853" },
	{ code: "MK", label: "Macedônia", phone: "389" },
	{ code: "MG", label: "Madagascar", phone: "261" },
	{ code: "MY", label: "Malasia", phone: "60" },
	{ code: "MW", label: "Malawi", phone: "265" },
	{ code: "ML", label: "Mali", phone: "223" },
	{ code: "MT", label: "Malta", phone: "356" },
	{ code: "MA", label: "Marruecos", phone: "212" },
	{ code: "MQ", label: "Martinica", phone: "596" },
	{ code: "MU", label: "Mauricio", phone: "230" },
	{ code: "MR", label: "Mauritania", phone: "222" },
	{ code: "YT", label: "Mayotte", phone: "262" },
	{ code: "FM", label: "Micronesia", phone: "691" },
	{ code: "MD", label: "Moldavia", phone: "373" },
	{ code: "MN", label: "Mongolia", phone: "976" },
	{ code: "ME", label: "Montenegro", phone: "382" },
	{ code: "MS", label: "Montserrat", phone: "1664" },
	{ code: "MZ", label: "Mozambique", phone: "258" },
	{ code: "NA", label: "Namibia", phone: "264" },
	{ code: "NR", label: "Nauru", phone: "674" },
	{ code: "NP", label: "Nepal", phone: "977" },
	{ code: "NI", label: "Nicaragua", phone: "505" },
	{ code: "NE", label: "Niger", phone: "227" },
	{ code: "NG", label: "Nigeria", phone: "234" },
	{ code: "NU", label: "Niue", phone: "683" },
	{ code: "NO", label: "Noruega", phone: "47" },
	{ code: "NC", label: "Nueva Caledonia", phone: "687" },
	{ code: "NZ", label: "Nueva Zelanda", phone: "64" },
	{ code: "OM", label: "Omán", phone: "968" },
	{ code: "NL", label: "Países Bajos", phone: "31" },
	{ code: "PK", label: "Pakistán", phone: "92" },
	{ code: "PW", label: "Palau", phone: "680" },
	{ code: "PS", label: "Palestina", phone: "970" },
	{ code: "PA", label: "Panamá", phone: "507" },
	{ code: "PG", label: "Papúa Nueva Guinea", phone: "675" },
	{ code: "PF", label: "Polinesia Francesa", phone: "689" },
	{ code: "PL", label: "Polonia", phone: "48" },
	{ code: "PT", label: "Portugal", phone: "351" },
	{ code: "PR", label: "Puerto Rico", phone: "1" },
	{ code: "QA", label: "Qatar", phone: "974" },
	{ code: "GB", label: "Reino Unido", phone: "44" },
	{ code: "CF", label: "República Centroafricana", phone: "236" },
	{ code: "CZ", label: "República Checa", phone: "420" },
	{ code: "DO", label: "República Dominicana", phone: "1809" },
	{ code: "SS", label: "República de Sudán del Sur", phone: "211" },
	{ code: "RE", label: "Reunión", phone: "262" },
	{ code: "RW", label: "Ruanda", phone: "250" },
	{ code: "RO", label: "Rumanía", phone: "40" },
	{ code: "RU", label: "Rusia", phone: "7" },
	{ code: "EH", label: "Sahara Occidental", phone: "212" },
	{ code: "WS", label: "Samoa", phone: "685" },
	{ code: "AS", label: "Samoa Americana", phone: "1684" },
	{ code: "BL", label: "San Bartolomé", phone: "590" },
	{ code: "KN", label: "San Cristóbal y Nieves", phone: "1869" },
	{ code: "SM", label: "San Marino", phone: "378" },
	{ code: "MF", label: "San Martín (Francia)", phone: "1599" },
	{ code: "PM", label: "San Pedro y Miquelón", phone: "508" },
	{ code: "VC", label: "San Vicente y las Granadinas", phone: "1784" },
	{ code: "SH", label: "Santa Elena", phone: "290" },
	{ code: "LC", label: "Santa Lucía", phone: "1758" },
	{ code: "ST", label: "Santo Tomé y Príncipe", phone: "239" },
	{ code: "SN", label: "Senegal", phone: "221" },
	{ code: "RS", label: "Serbia", phone: "381" },
	{ code: "SC", label: "Seychelles", phone: "248" },
	{ code: "SL", label: "Sierra Leona", phone: "232" },
	{ code: "SG", label: "Singapur", phone: "65" },
	{ code: "SX", label: "Sint Maarten", phone: "1721" },
	{ code: "SY", label: "Siria", phone: "963" },
	{ code: "SO", label: "Somalia", phone: "252" },
	{ code: "LK", label: "Sri lanka", phone: "94" },
	{ code: "ZA", label: "Sudáfrica", phone: "27" },
	{ code: "SD", label: "Sudán", phone: "249" },
	{ code: "SE", label: "Suecia", phone: "46" },
	{ code: "CH", label: "Suiza", phone: "41" },
	{ code: "SR", label: "Surinám", phone: "597" },
	{ code: "SJ", label: "Svalbard y Jan Mayen", phone: "47" },
	{ code: "SZ", label: "Swazilandia", phone: "268" },
	{ code: "TJ", label: "Tayikistán", phone: "992" },
	{ code: "TH", label: "Tailandia", phone: "66" },
	{ code: "TW", label: "Taiwán", phone: "886" },
	{ code: "TZ", label: "Tanzania", phone: "255" },
	{ code: "IO", label: "Territorio Británico del Océano Índico", phone: "246" },
	{ code: "TL", label: "Timor Oriental", phone: "670" },
	{ code: "TG", label: "Togo", phone: "228" },
	{ code: "TK", label: "Tokelau", phone: "690" },
	{ code: "TO", label: "Tonga", phone: "676" },
	{ code: "TT", label: "Trinidad y Tobago", phone: "1868" },
	{ code: "TN", label: "Tunez", phone: "216" },
	{ code: "TM", label: "Turkmenistán", phone: "993" },
	{ code: "TR", label: "Turquía", phone: "90" },
	{ code: "TV", label: "Tuvalu", phone: "688" },
	{ code: "UA", label: "Ucrania", phone: "380" },
	{ code: "UG", label: "Uganda", phone: "256" },
	{ code: "UZ", label: "Uzbekistán", phone: "998" },
	{ code: "VU", label: "Vanuatu", phone: "678" },
	{ code: "VN", label: "Vietnam", phone: "84" },
	{ code: "WF", label: "Wallis y Futuna", phone: "681" },
	{ code: "YE", label: "Yemen", phone: "967" },
	{ code: "DJ", label: "Yibuti", phone: "253" },
	{ code: "ZM", label: "Zambia", phone: "260" },
	{ code: "ZW", label: "Zimbabue", phone: "263" },
];
export default countries;
